export default "__VITE_ASSET__Bt89oOME__"